import React from 'react'
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const Cardcompanies = () => {
    const { t } = useTranslation();
    return (
        <>
            <NavLink to={t('url.podjetja')} className='card-link'>
                <div className="card">
                    <img src={`${process.env.PUBLIC_URL}/images/cards/product-companies.png`} alt="Podjetja" />
                    <div className="card-text">
                        <h3>{t('pages.podjetja')}</h3>
                    </div>
                    <div className="readmore">
                        <NavLink to={t('url.podjetja')}>{t('products.readmore')}</NavLink>
                    </div>
                </div>
            </NavLink>
            <div className="card-shadow">
                <img src={`${process.env.PUBLIC_URL}/images/cards/shadow.png`} alt="shadow card" />
            </div>
        </>
    )
}

export default Cardcompanies